/* FF360 v1.11 - Uniform product photos.
   Store photos have different amounts of empty background around the pack, so some
   products look tiny and others fill the card. This measures where the product
   actually sits in each photo (ignoring the background colour) and scales/centres it
   so every pack fills the same share of its box. Visual only: the image file, its
   size and its URL are untouched. If anything fails, the photo is left as it was. */
(function () {
  'use strict';
  var SELECTOR = '.product-card__image, .ds-cat__media img, .dsh__pk img, .product-card-horizontal img, .dsb__media img';
  var FILL = 0.84;        // product occupies 84% of the box on its longer side
  var MAX_SCALE = 2.6;    // never blow a small photo up more than this
  var SAMPLE = 120;       // analyse a 120px thumbnail - fast and accurate enough
  var cache = {};

  function bbox(img) {
    var key = img.currentSrc || img.src;
    if (cache[key] !== undefined) return cache[key];
    var nw = img.naturalWidth, nh = img.naturalHeight;
    if (!nw || !nh) return null;
    var k = SAMPLE / Math.max(nw, nh);
    var w = Math.max(1, Math.round(nw * k)), h = Math.max(1, Math.round(nh * k));
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, w, h);
    var d;
    try { d = ctx.getImageData(0, 0, w, h).data; } catch (e) { cache[key] = null; return null; }

    // background = average of the four corners
    function px(x, y) { var i = (y * w + x) * 4; return [d[i], d[i + 1], d[i + 2], d[i + 3]]; }
    var cs = [px(0, 0), px(w - 1, 0), px(0, h - 1), px(w - 1, h - 1)];
    var bg = [0, 0, 0, 0];
    cs.forEach(function (p) { for (var j = 0; j < 4; j++) bg[j] += p[j] / 4; });
    var transparentBg = bg[3] < 40;

    var x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var i = (y * w + x) * 4, a = d[i + 3], fg;
        if (transparentBg) fg = a > 40;
        else fg = a > 40 && (Math.abs(d[i] - bg[0]) + Math.abs(d[i + 1] - bg[1]) + Math.abs(d[i + 2] - bg[2])) > 42;
        if (fg) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      }
    }
    if (x1 < 0) { cache[key] = null; return null; }
    var r = { x0: x0 / w, y0: y0 / h, x1: (x1 + 1) / w, y1: (y1 + 1) / h, ar: nw / nh };
    // product already fills the photo, or detection is unreliable -> leave alone
    if ((r.x1 - r.x0) > 0.97 && (r.y1 - r.y0) > 0.97) r = null;
    cache[key] = r;
    return r;
  }

  function fit(img) {
    if (!img.complete || !img.naturalWidth) return;
    var r = bbox(img);
    if (!r) return;
    img.classList.add('ff-fit');
    var W = img.clientWidth, H = img.clientHeight;
    if (!W || !H) return;
    // where object-fit:contain draws the photo inside the element
    var s0 = Math.min(W / img.naturalWidth, H / img.naturalHeight);
    var dw = img.naturalWidth * s0, dh = img.naturalHeight * s0;
    var ox = (W - dw) / 2, oy = (H - dh) / 2;
    var bx0 = ox + r.x0 * dw, bx1 = ox + r.x1 * dw, by0 = oy + r.y0 * dh, by1 = oy + r.y1 * dh;
    var bw = bx1 - bx0, bh = by1 - by0;
    var s = Math.min((FILL * W) / bw, (FILL * H) / bh, MAX_SCALE);
    if (s < 1) s = Math.min(1, (0.96 * W) / bw, (0.96 * H) / bh);
    var cx = (bx0 + bx1) / 2, cy = (by0 + by1) / 2;
    var tx = W / 2 - s * cx, ty = H / 2 - s * cy;
    // store as % of the element so it survives resizes without re-measuring
    img.style.setProperty('--ff-tx', (tx / W * 100).toFixed(3) + '%');
    img.style.setProperty('--ff-ty', (ty / H * 100).toFixed(3) + '%');
    img.style.setProperty('--ff-s', s.toFixed(4));
  }

  function hook(img) {
    if (img.__ffFit) return;
    img.__ffFit = true;
    if (img.complete && img.naturalWidth) fit(img);
    img.addEventListener('load', function () { fit(img); });
  }

  function scan(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(hook);
  }

  var resizeT;
  window.addEventListener('resize', function () {
    clearTimeout(resizeT);
    resizeT = setTimeout(function () { document.querySelectorAll('img.ff-fit').forEach(fit); }, 200);
  });

  function init() {
    scan();
    var pending;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(scan, 120);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
